﻿import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import _ from "lodash";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import CreateReturnHead from "./CreateReturnHead";
import CreateReturnTable from "./CreateReturnTable";
import CreateReturnSearch from "./CreateReturnSearch";

import classes from "./createReturn.module.scss";

import { baseOrderReturn } from "./createReturn.constants";
import { hasPermission } from "@/services/Utils";
import api from "@/services/api.service";
import { baseFilterOrders } from "../orders_return_constants";

const CreateReturn = () => {
	const navigate = useNavigate();
	const { addToast } = useToasts();
	const queryClient = useQueryClient();

	const { estate_id, type_currency, search } = useSelector((state) => state.auth.filter);

	const { option, code } = useParams();

	const [isFetching, setIsFetching] = useState(true);
	const [isFetchingTable, setIsFetchingTable] = useState(false);
	const [permissions, setPermissions] = useState([]);

	const [data, setData] = useState({ ...baseOrderReturn });
	const [items, setItems] = useState([]);
	const [dealers, setDealers] = useState([]);
	const [ordersSale, setOrdersSale] = useState([]);
	const [ordersDelivery, setOrdersDelivery] = useState([]);
	const [activeDetail, setActiveDetail] = useState(true);
	const [activeProduct, setActiveProduct] = useState(true);

	const [openSearch, setOpenSearch] = useState(false);

	const base = { ...baseFilterOrders, estate_id, type_currency, search };

	useEffect(() => {
		api.get("/client/orders_return/data_create", {
			code,
		}).then((response) => {
			const { dealers, orders_sale, orders_delivery, permissions, data } = response;
			setDealers(dealers);
			setOrdersSale(orders_sale);
			setOrdersDelivery(orders_delivery);
			setPermissions(permissions);

			if (data) {
				setData(data);
			}

			setIsFetching(false);
		});

		// eslint-disable-next-line
	}, []);

	const validSave = () => {
		if (!data.code) {
			addToast("Debe ingresar el código de la nota de crédito para continuar", {
				appearance: "error",
			});
			return false;
		}

		if (data.details.length === 0) {
			addToast("Debe ingresar al menos un producto para continuar", {
				appearance: "error",
			});
			return false;
		}

		let valid_item = true;
		let message = "";
		data.details.forEach((item, _i) => {
			if (!item.inventory_id) {
				message = "Debe seleccionar un código en todos los items.";
				valid_item = false;
				return;
			}

			if (!item.quantity_return || Number(item.quantity_return) === 0) {
				message = "Debe ingresar una cantidad de devolución en todos los items.";
				valid_item = false;
				return;
			}

			if (item.quantity_return > item.quantity) {
				message = "La cantidad de devolución debe ser menor o igual a la cantidad disponible en todos los items.";
				valid_item = false;
				return;
			}
		});

		if (!valid_item) {
			addToast(message, {
				appearance: "error",
			});
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			setIsFetching(true);

			api.post("/client/orders_return/save", { ...data, option })
				.then((response) => {
					setIsFetching(false);

					if (Object.prototype.hasOwnProperty.call(response, "list")) {
						addToast("Nota de Crédito guardada exitosamente", {
							appearance: "success",
						});

						queryClient.setQueryData(["purchase_orders_return", { ...base }], response);

						navigate("/nota_credito");
					}
				})
				.catch((e) => {
					console.error(e);
				});
		}
	};

	return (
		<>
			<Head title={option === "ingresar" ? "Ingresar Nota de Crédito" : `${_.capitalize(option)} Nota de Crédito`} />

			{isFetching ? (
				<Fetching />
			) : (
				<Row className={classes.row_global_card}>
					<CreateReturnHead
						data={data}
						setData={setData}
						setItems={setItems}
						dealers={dealers}
						ordersSale={ordersSale}
						ordersDelivery={ordersDelivery}
						activeDetail={activeDetail}
						setActiveDetail={setActiveDetail}
						setIsFetching={setIsFetchingTable}
					/>

					<CreateReturnTable
						data={data}
						setData={setData}
						activeProduct={activeProduct}
						setActiveProduct={setActiveProduct}
						items={items}
						isFetchingTable={isFetchingTable}
						setOpenSearch={setOpenSearch}
					/>

					<Col md={12} className={classes.col_base}>
						<Col className={classes.buttons} md={12} xs={12}>
							<div className={classes.buttonClose}>
								<div onClick={() => navigate("/nota_credito")}>CERRAR</div>
							</div>

							{data && option === "ingresar" && hasPermission("create", permissions) && (
								<div className={classes.buttonSave}>
									<div onClick={() => handleSave()}>GUARDAR</div>
								</div>
							)}
						</Col>
					</Col>

					<CreateReturnSearch data={data} setData={setData} items={items} setItems={setItems} openSearch={openSearch} setOpenSearch={setOpenSearch} />
				</Row>
			)}
		</>
	);
};

export default CreateReturn;
